module.exports = __webpack_public_path__ + "static/img/404.d8a9e0a3.png";